/** @module AQL/Workflow/FinalInspectionHeader */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action",
	"csi/def/Action",
	"csi/def/Parameter",
	"csi/def/Request",
	"csi/def/ViewRef",
	"csi/heading/stateColorResolver",
	"csi/html",
	"csi/html/StateWidget",
	"csi/locale",
	"csi/page",
	"csi/widget/FIStateDropDown",
	"csi/xml",
	"AQL/PartialPassForm"
], function (declare, lang, csiAction, Action, Parameter, Request, ViewRef, stateColorResolver, html,
	StateWidget, locale, page, FIStateDropDown, xml, PartialPassForm) {

	return declare(StateWidget, {
		/** @property {string} batchString - "Batch" for Batch Level, "" for Inspection Level */
		batchString: "",

		/**
		 * Drop down selection
		 * @param {MenuItem} selection
		 */
		dropDownSelect: function (selection) {
			const { batchString, ctx } = this;
			const { view } = ctx;
			const node = ctx.getNode();
			const URL = xml.nodeGetURL(node);
			let action;
			switch (selection.label) {
				case locale.resource(`PartiallyPassInspection${batchString}`):
					action = lang.mixin(new Action(), {
						m_viewRef: lang.mixin(new ViewRef(), {
							m_id: `PartialPassForm${batchString}`,
							m_url: URL
						}),
						m_postAction: () => page.refreshRootView(),
						m_request: lang.mixin(new Request(), {
							m_module: "AQL",
							m_operation: `PartiallyPassInspection${batchString}`,
							m_parameters: [
								lang.mixin(new Parameter(), {
									m_id: "URL",
									m_typeAttr: "ref",
									m_value: URL
								})
							]
						})
					});
					action.resolve();
					view.defView.classController = PartialPassForm;
					csiAction.invoke(view, node, action, {
						getTitle: () => locale.resource(`PartiallyPassInspection${batchString}`),
					});
					this.closeDropDown();
					return;
				case locale.resource("PassInspection"):
					action = "Pass";
					break;
				case locale.resource("FailInspection"):
					action = "Fail";
					break;
				case locale.resource("AbandonInspection"):
					action = "Abandon";
					break;
				default:
					this.closeDropDown();
					return;
			}
			action = lang.mixin(new Action(), {
				m_id: `${action}InspectionBatch`,
				m_postAction: () => page.refreshRootView(),
				m_request: lang.mixin(new Request(), {
					m_module: "AQL",
					m_operation: `${action}Inspection${batchString}`,
				})
			});
			action.resolve();
			csiAction.invoke(view, null, action, { m_urlNode: URL });
		},

		/**
		 * @override
		 * Setup state header and add dropdown button to pass / fail
		 */
		_processHtml: function (ctx, dom) {
			this.inherited(arguments);

			const { batchString } = this;
			const node = ctx.getNode();
			const css = stateColorResolver.getStateCss(node);
			const state = node.InspectionState || node.InspectionBatchState;
			const stateEnumValue = xml.enumGetText(state);

			const ePassOrFail = dom.querySelector(".PassOrFail");
			if (ePassOrFail) {
				const passOrFailButton = new FIStateDropDown({
					batchString,
					ctx,
					css,
					menuItems: [
						"&nbsp;",
						locale.resource("PassInspection"),
						locale.resource("PartiallyPassInspection"),
						locale.resource("FailInspection"),
						locale.resource("AbandonInspection"),
					],
					node,
					stateEnumValue,
					dropDownSelect: this.dropDownSelect,
				});
				passOrFailButton.startup();
				passOrFailButton.placeAt(ePassOrFail);
			}

			const enumNode = dom.querySelector(`.${stateEnumValue}`);
			if (enumNode) {
				enumNode.classList.add(...css.split(" "));
			}

			dom.querySelectorAll(".stateWrapper").forEach((entry, index) => {
				const stateName = entry.classList[1];
				if (stateName !== "PassOrFail") {
					html.text(entry, locale.getEnumName(`Inspection${batchString}State:${stateName}`, true));
				}
			});
		}
	});
});